import Immutable from 'immutable';
import {
  FLAG_GETTING_COMPANY_AREA_RESPONSABLE,
  GET_COMPANY_AREA_RESPONSABLE,
  CLEAR_COMPANY_AREA_RESPONSABLE,
} from '../../../actions/types/mechanical-maintenance';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Set(),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_COMPANY_AREA_RESPONSABLE:
      return state.setIn(['all', 'loading'], payload);
    case GET_COMPANY_AREA_RESPONSABLE:
      return state.setIn(['all', 'content'], Immutable.Set(payload));
    case CLEAR_COMPANY_AREA_RESPONSABLE:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    default:
      return state;
  }
};
